import settings from './settings/settings.routes';
import knowledge from './knowledge/knowledge.routes';
import billing from './billing/billing.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import appointments from './appointments/appointments.routes';
import branches from './branches/branches.routes';
import knowledgeImprovement from './knowledgeimprovement/knowledgeimprovement.routes';
import whatsappTemplate from './whatsapp/whatsapp.routes';
import rentalBookingsRoutes from './rentalBookings/rentalBookings.routes';
import rentalBranchesRoutes from './rentalBranches/rentalBranches.routes';
import whitelist from './whitelist/whitelist.routes';
import n8nRoutes from './n8n/n8n.routes';
import condoMngtRoutes from './condoMngt/condoMngt.routes';
import googleSheet from './googleSheet/googleSheet.routes';
import organization from './organization/organization.routes';
import realEstate from './realEstate/realEstate.routes';
import coLiving from './coLiving/coLiving.routes';
// import appointmentsV3 from './appointmentsV3/appointmentsV3.routes';
import eVoucher from './eVoucher/eVoucher.routes';
import mantap from './mantap/mantap.routes';
import onboardingRoutes from './onboarding/onboarding.routes';
import onboardingGuidesRoutes from './onboardingGuides/onboardingGuides.routes';
import onboardingShellRoutes from './onboardingShell/onboardingShell.routes';
const AppContainer = () => import('./Dashboard.vue');
const Captain = () => import('./Captain.vue');
const Suspended = () => import('./suspended/Index.vue');
const PricingTable = () => import('./subscription/PricingTable.vue');
const SubscriptionCheckError = () =>
  import('./subscription/SubscriptionCheckError.vue');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/captain'),
          name: 'captain',
          component: Captain,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        // Service agents should only have access to appointments and branches routes
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...knowledge.routes,
        ...billing.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...appointments.routes,
        ...branches.routes, // Conditional: visible for all accounts except 276
        ...knowledgeImprovement.routes,
        ...whatsappTemplate.routes,
        // ...rentalBookingsRoutes.routes,
        // ...rentalBranchesRoutes.routes,
        ...whitelist.routes,
        ...n8nRoutes.routes,
        ...condoMngtRoutes.routes,
        ...googleSheet.routes,
        ...organization.routes,
        ...realEstate.routes,
        ...coLiving.routes,
        // ...appointmentsV3.routes,
        ...eVoucher.routes,
        ...onboardingRoutes.routes,
        ...onboardingGuidesRoutes.routes,
        ...mantap.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'service_agent'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/pricing_table'),
      name: 'pricing_table',
      component: PricingTable,
      meta: {
        permissions: ['administrator', 'agent', 'service_agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/subscription_error'),
      name: 'subscription_error',
      component: SubscriptionCheckError,
      meta: {
        permissions: ['administrator', 'agent', 'service_agent'],
      },
    },
    ...onboardingShellRoutes.routes,
  ],
};
